import { styled } from "@linaria/react";
import { styleTokens } from "@ideally-ltd/design-tokens";
import { Checkbox } from "primereact/checkbox";

const CheckboxWrapper = styled.div`
  user-select: none;
  & > label {
    cursor: pointer;
    text-align: left;
  }
`;
const PCheckbox = styled(Checkbox)<{ ref: React.ForwardedRef<Checkbox> }>`
  &.p-checkbox.p-component {
    & > .p-checkbox-box {
      border: 1px solid ${styleTokens.checkbox.border.color};
    }
    &:hover > .p-checkbox-box {
      border: 1px solid ${styleTokens.checkbox.hover.border.color};
      &.p-highlight {
        border-color: ${styleTokens.checkbox.hover.border.color};
      }
    }
    &.p-highlight > .p-checkbox-box {
      background: ${styleTokens.checkbox.checked.background};
      border-radius: 1px solid ${styleTokens.checkbox.border.radius};
      border: 2px solid ${styleTokens.checkbox.checked.border.color};
      color: ${styleTokens.checkbox.icon.checked.color};
      & > svg {
        color: ${styleTokens.checkbox.icon.checked.color};
      }
    }
  }
`;
export const PCheckboxStyle = { CheckboxWrapper, PCheckbox };
// p-highlight
